/**
 * 🎨 DISPLAY FALLBACKS
 *
 * Standardized fallback values for XSS protection using SafeText component.
 * This ensures consistent user experience across the application when user data is missing or invalid.
 */

export const SECURITY_FALLBACKS = {
  // User-related fallbacks
  USERNAME: 'Unknown User',
  USER_INITIAL: '?',
  EMAIL: '', // Empty string - don't show fallback for missing emails

  // Name-related fallbacks
  FIRST_NAME: '',
  LAST_NAME: '',
  FULL_NAME: 'Unknown User',

  // Tournament-related fallbacks
  TOURNAMENT_NAME: 'Unknown Tournament Name',
  TOURNAMENT_DESCRIPTION: 'Tournament details cannot be displayed',
  TOURNAMENT_CREATOR: 'Unknown Creator',

  // Generic fallbacks
  TEXT: '',
  DISPLAY_TEXT: 'N/A',
} as const;

/**
 * Typed fallback values to ensure type safety
 */
export type SecurityFallback =
  (typeof SECURITY_FALLBACKS)[keyof typeof SECURITY_FALLBACKS];
